import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { tradesApi } from '../api';

export const usePnl = (
    month: number,
    year: number,
    brokerId: string | null,
    masterUserId?: string | null,
    options?: { enabled?: boolean }
) => {
    const requested = options?.enabled !== false;
    const enabledForMaster = masterUserId ? !!masterUserId : true;
    return useQuery({
        queryKey: ['pnl-calendar', month, year, brokerId, masterUserId ?? 'self'],
        queryFn: () => tradesApi.getPnlCalendar({ month, year, brokerId, masterUserId: masterUserId || undefined }),
        placeholderData: keepPreviousData,
        enabled: requested && enabledForMaster,
    });
};
